export function createStyleElement(id: string, data: string) {
  if (!document.getElementById(id)) {
    const styleElement = document.createElement('style');
    styleElement.appendChild(document.createTextNode(data));
    styleElement.id = id;

    document.head.appendChild(styleElement);
  }
}

export function removeStyleElement(id: string) {
  const styleElement = document.getElementById(id);
  if (styleElement) {
    styleElement.remove();
  }
}
